/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cas_Warning_Hide_ImmediatelyInputs */

const en_cas_warning_hide_immediately = /** @type {(inputs: Cas_Warning_Hide_ImmediatelyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This will immediately hide the CAS tab for all investors`)
};

/**
* | output |
* | --- |
* | "This will immediately hide the CAS tab for all investors" |
*
* @param {Cas_Warning_Hide_ImmediatelyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const cas_warning_hide_immediately = /** @type {((inputs?: Cas_Warning_Hide_ImmediatelyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cas_Warning_Hide_ImmediatelyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cas_warning_hide_immediately(inputs)
});